import store from '@/store'
import os from '@utils/os'
import Request from '@request'
import api from '@api'
export default {
    type: 'authorization',
    // extra: ,

    path: ['/meetingPlaybackDetail', '/', '/meetingHome', '/meetingDetail', '/expertSharePage', '/doctorSharePage', '/doctorSeriesCourses', '/personalCenter', '/homeConsultingDetail', '/doctorMainPage', '/productDetail', '/companyDetail'],
    // path: [],
    handler (info) {
        return new Promise(async (resolve, reject) => {

            const {
                to,
                from,
            } = info
            if (to.query.pf == 'QC') {
                // 雀巢公司会议对接
                // // 第二次进入
                // if (to.query.isNoFrist) {
                //     Request.post(api.meeting.getqcState, {
                //         code: to.query.code,
                //         appid: to.query.appid
                //     }).then(res => {
                //         if (res.status == '200') {
                //             console.log(res.data, 'getqcState')
                //             const { url, state, userInfo = {} } = res.data
                //             if (state != 1) {
                //                 window.location.href = url
                //             } else {
                //                 store.commit('user/setUserLoginData', userInfo)
                //                 store.commit('user/setLogin', true)
                resolve()
                //             }
                //         } else {
                //             Request.post(api.meeting.getqcUrl, {
                //                 url: `${window.location.href}&isNoFrist=true`
                //             }).then(res => {
                //                 window.location.href = res.data.url
                //             })
                //         }
                //     }).catch(err => {

                //     })
                // } else {
                //     Request.post(api.meeting.getqcUrl, {
                //         url: `${window.location.href}&isNoFrist=true`
                //     }).then(res => {
                //         window.location.href = res.data.url
                //     })
                // }


            } else {
                if (store.getters.isInApp) return resolve()
                if (store.getters.isLogin === undefined) await store.dispatch('user/getLoginStatus').catch(_ => _)
                const openid = localStorage.getItem('wxopenid')
                if (os.isWXWork() && os.getDevice() === 'mac') { // 修复MAC企业微信分享卡片打不开
                    const wxWorkReload = sessionStorage.getItem('isWXWorkReload')
                    if (wxWorkReload) sessionStorage.removeItem('isWXWorkReload')
                    else {
                        sessionStorage.setItem('isWXWorkReload', 'needReload')
                        setTimeout(() => {
                            window.location.reload()
                        }, 1000)
                    }
                }

                if (window.self === window.top && os.isWechat() !== 3 && !store.getters.isLogin && (!openid || store.state.wechat.authInfo === undefined)) setTimeout(() => {
                    store.dispatch('wechat/getAuthAddress')
                }, 100)
                resolve()
            }


        })
    }
}